module.exports = __webpack_public_path__ + "static/media/download.0f7d99cc.svg";